import { isNil, tryGetValue } from '../../utils';
import { SerializableObject } from './serializable-object';
import { User } from './user.do';

/** The Invite domain object. */
export class Invite extends SerializableObject {
  id: string;
  status: string;
  inviteEmail: string;
  emailSentUtc: string;
  targetOrganizationId: string;
  createdUtc: string;
  createdBy: string;
  inviteCreatedBy: User;
  approvedUtc: string;
  grantRole: string;
  erpUsername: string;
  fullName: string;
  groupIds: string[];

  public buildFromJSON(json: Object) {
    super.buildFromJSON(json);
    let createdByJson = tryGetValue<string>(json, 'inviteCreatedBy');
    if (!isNil(createdByJson)) {
      this.inviteCreatedBy = new User(createdByJson);
    }
  }

}
